import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import Logo from '../common/Logo';
import '../salon/styles/base.css'; // Import global form styles
import './Auth.css';

const ForgotPassword = () => {
  const { t, translateMessage } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    const result = await forgotPassword(email);
    
    if (result.success) {
      setSuccess(translateMessage(result.message));
      setEmail('');
    } else {
      setError(translateMessage(result.error));
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <Logo />
          <p>{t('auth.resetPasswordDesc')}</p>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        {success && (
          <div className="success-message">
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit} className="base-form">
          <div className="form-group">
            <label htmlFor="email">{t('auth.email')}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder={t('auth.enterEmailAddress')}
            />
          </div>

          <button 
            type="submit" 
            className="salon-button primary"
            disabled={loading}
          >
            {loading ? t('auth.sending') : t('auth.sendResetLink')}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/login" className="link">
            {t('auth.backToSignIn')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
